export const translations = {
  es: {
    nav: {
      what: "¿Qué necesitas?",
      how: "Cómo funciona",
      trust: "Confianza",
      pros: "Profesionales",
      help: "Necesito ayuda",
      pro: "Quiero ser profesional",
    },
    hero: {
      eyebrow: "Ayuda de confianza en Madrid",
      titleLines: ["Todo lo que necesitas", "para vivir bien,", "en casa."],
      accentWord: "vivir bien",
      subtitle:
        "Desde ayuda en casa hasta cuidado de mascotas, acompañamiento y recados. HomeHealthy te conecta con personas de confianza que pueden ayudarte en tu día a día.",
      ctaPrimary: "Necesito ayuda",
      ctaSecondary: "Quiero ser profesional",
      note: "Empezamos en Madrid.",
    },
    categories: {
      hogar: { label: "Hogar", desc: "Limpieza y pequeñas ayudas en casa." },
      mascotas: { label: "Mascotas", desc: "Paseos, compañía y cuidado de mascotas." },
      acompanamiento: { label: "Acompañamiento", desc: "Compañía y acompañamiento para tareas cotidianas." },
      recados: { label: "Recados", desc: "Compras, recados y pequeñas gestiones." },
    },
    what: {
      eyebrow: "Servicios",
      title: "¿Qué necesitas hoy?",
      subtitle: "Cuéntanos qué necesitas y nosotros buscamos la persona adecuada para ayudarte.",
      cta: "Solicitar",
    },
    how: {
      eyebrow: "Así de fácil",
      title: "Ayuda en cuatro pasos.",
      steps: [
        { n: "01", t: "Cuéntanos qué necesitas", d: "Elige el servicio y describe tu situación en menos de 2 minutos." },
        { n: "02", t: "Buscamos la persona adecuada", d: "Nuestro equipo revisa tu solicitud y encuentra a alguien de confianza." },
        { n: "03", t: "Recibe ayuda", d: "Confirmamos disponibilidad, horario y precio antes de empezar." },
        { n: "04", t: "Valora tu experiencia", d: "Después del servicio, cuéntanos cómo ha ido." },
      ],
    },
    trust: {
      eyebrow: "Confianza",
      title: "Personas ayudando a personas.",
      body: "HomeHealthy nace para hacer más fácil el día a día, conectando necesidades reales con personas dispuestas a ayudar.",
    },
    prosSection: {
      eyebrow: "Profesionales",
      title: "Forma parte de HomeHealthy.",
      body: "Buscamos personas responsables y profesionales que quieran ofrecer sus servicios y ayudar a otras personas en Madrid.",
      benefits: [
        "Recibe oportunidades de servicio",
        "Elige las zonas donde quieres trabajar",
        "Indica tu disponibilidad",
        "Construye tu reputación",
        "Forma parte de una comunidad local",
      ],
      cta: "Quiero ser profesional",
    },
    madrid: {
      title: "Estamos empezando en Madrid.",
      body: "Nuestro objetivo es construir una red local de confianza, empezando por Madrid y creciendo barrio a barrio.",
    },
    ctaFinal: {
      title: "¿Necesitas una mano hoy?",
      subtitle: "Cuéntanos qué necesitas y nos ponemos a buscar la persona adecuada para ti.",
      cta: "Necesito ayuda",
    },
    footer: {
      tagline: "Todo lo que necesitas para vivir bien, en casa.",
      links: { home: "Inicio", how: "Cómo funciona", what: "Servicios", pros: "Profesionales", help: "Necesito ayuda" },
      rights: "Todos los derechos reservados.",
    },
    publicPro: {
      verified: "Profesional verificado",
      verifiedNote: "HomeHealthy ha revisado y verificado a esta persona.",
      serviceArea: "Zona de servicio",
      services: "Servicios",
      experience: "Experiencia",
      languages: "Idiomas",
      about: "Sobre mí",
      reviews: "Valoraciones",
      servicesDone: "servicios realizados",
      cta: "Necesito ayuda",
      directoryTitle: "Profesionales verificados",
      directorySubtitle: "Personas revisadas y verificadas por HomeHealthy en Madrid.",
      back: "Volver",
      empty: "Todavía no hay profesionales verificados publicados.",
      notFound: "Este perfil no está disponible.",
    },
    verifiedTeaser: {
      title: "Profesionales verificados",
      subtitle: "Personas revisadas por HomeHealthy para ofrecerte una red de confianza.",
      cta: "Conoce a nuestros profesionales",
    },
    wizard: {
      title: "Necesito ayuda",
      steps: ["¿Qué necesitas?", "¿Dónde?", "¿Cuándo?", "Cuéntanos más", "Contacto"],
      back: "Atrás",
      next: "Continuar",
      submit: "Solicitar ayuda",
      submitting: "Enviando…",
      step1: { title: "¿Qué necesitas?" },
      step2: {
        title: "¿Dónde necesitas ayuda?",
        postal: "Código postal",
        neighborhood: "Barrio",
        address: "Dirección aproximada (opcional)",
      },
      step3: {
        title: "¿Cuándo?",
        when: ["Hoy", "Mañana", "Esta semana", "Elegir fecha"],
        date: "Fecha",
        timeRange: "Franja horaria",
        timeOptions: ["Mañana", "Mediodía", "Tarde", "Flexible"],
        duration: "Duración aproximada",
        durationOptions: ["1 hora", "2 horas", "3 horas", "Media jornada", "No lo sé"],
      },
      step4: { title: "Cuéntanos un poco más", placeholder: "Describe qué necesitas, cualquier detalle que nos ayude…" },
      step5: {
        title: "¿Cómo podemos contactarte?",
        name: "Nombre",
        phone: "Teléfono",
        email: "Email",
        contact: "¿Cómo prefieres que te contactemos?",
        contactOptions: ["WhatsApp", "Llamada", "Email"],
      },
      required: "Completa los campos obligatorios.",
      error: "Algo ha ido mal. Inténtalo de nuevo.",
      success: {
        title: "¡Solicitud recibida!",
        body: "Gracias por confiar en HomeHealthy. Nuestro equipo revisará tu solicitud y buscará una persona adecuada para ayudarte en Madrid. Te contactaremos para confirmar disponibilidad, precio y horario.",
        refLabel: "Tu solicitud",
        supportTitle: "¿Necesitas ayuda?",
        supportBody: "Escríbenos por WhatsApp y te ayudamos con tu solicitud.",
        whatsapp: "Escríbenos por WhatsApp",
        back: "Volver a HomeHealthy",
      },
    },
    proWizard: {
      title: "Quiero ser profesional",
      steps: ["Datos personales", "Servicios", "Experiencia", "Documentación"],
      back: "Atrás",
      next: "Continuar",
      submit: "Enviar solicitud",
      submitting: "Enviando…",
      s1: { title: "Datos personales", name: "Nombre", lastName: "Apellidos", phone: "Teléfono", email: "Email", city: "Ciudad", postal: "Código postal / zonas" },
      s2: { title: "¿Qué servicios ofreces?", hint: "Selecciona uno o varios." },
      s3: {
        title: "Experiencia",
        experience: "Experiencia",
        languages: "Idiomas",
        availability: "Disponibilidad",
        rate: "Precio orientativo por hora (€)",
        description: "Descripción personal",
      },
      s4: {
        title: "Documentación",
        note: "Añade tu foto de perfil y tu CV. Nos ayudará a revisar tu candidatura más rápido (opcional).",
        photo: "Foto de perfil",
        cv: "CV (PDF)",
        uploadPhoto: "Subir foto",
        uploadCv: "Subir CV",
        uploading: "Subiendo…",
        uploaded: "Subido ✓",
        status: "Al enviar, tu estado será PENDIENTE DE REVISIÓN.",
      },
      required: "Completa los campos obligatorios y al menos un servicio.",
      already: "Este email ya está registrado.",
      error: "Algo ha ido mal. Inténtalo de nuevo.",
      success: {
        title: "¡Solicitud recibida!",
        body: "Gracias por tu interés. Revisaremos tu información y nos pondremos en contacto contigo. Tu estado actual es PENDIENTE DE REVISIÓN.",
        back: "Volver a HomeHealthy",
      },
    },
    review: {
      title: "Valora tu experiencia",
      intro: "¿Cómo fue el servicio",
      comment: "Comentario (opcional)",
      submit: "Enviar valoración",
      submitting: "Enviando…",
      thanks: "¡Gracias por tu valoración!",
      already: "Esta solicitud ya ha sido valorada.",
      notfound: "No encontramos esa solicitud.",
      close: "Cerrar",
    },
    common: { close: "Cerrar", optional: "opcional", privacyPre: "He leído y acepto la", privacyLink: "política de privacidad", privacyErr: "Debes aceptar la política de privacidad." },
    ai: {
      analyze: "Analizar con IA",
      analyzing: "Analizando…",
      suggested: "Categoría sugerida",
      apply: "Usar",
      summaryLabel: "Resumen para el equipo",
      bio: "Generar con IA",
      bioLoading: "Generando…",
      chatTitle: "Asistente HomeHealthy",
      chatIntro: "Hola, soy el asistente de HomeHealthy. ¿En qué puedo ayudarte?",
      chatPlaceholder: "Escribe tu pregunta…",
      error: "El asistente no está disponible ahora.",
    },
  },

  en: {
    nav: {
      what: "What you need",
      how: "How it works",
      trust: "Trust",
      pros: "Professionals",
      help: "I need help",
      pro: "Become a professional",
    },
    hero: {
      eyebrow: "Trusted help in Madrid",
      titleLines: ["Everything you need", "to live well,", "at home."],
      accentWord: "live well",
      subtitle:
        "From help at home to pet care, companionship and errands. HomeHealthy connects you with trusted people who can help with your day to day.",
      ctaPrimary: "I need help",
      ctaSecondary: "Become a professional",
      note: "Starting in Madrid.",
    },
    categories: {
      hogar: { label: "Home", desc: "Cleaning and small help around the house." },
      mascotas: { label: "Pets", desc: "Walks, company and pet care." },
      acompanamiento: { label: "Companionship", desc: "Company and support for everyday tasks." },
      recados: { label: "Errands", desc: "Shopping, errands and small tasks." },
    },
    what: {
      eyebrow: "Services",
      title: "What do you need today?",
      subtitle: "Tell us what you need and we'll find the right person to help you.",
      cta: "Request",
    },
    how: {
      eyebrow: "This simple",
      title: "Help in four steps.",
      steps: [
        { n: "01", t: "Tell us what you need", d: "Pick the service and describe your situation in under 2 minutes." },
        { n: "02", t: "We find the right person", d: "Our team reviews your request and finds someone trustworthy." },
        { n: "03", t: "Get help", d: "We confirm availability, schedule and price before starting." },
        { n: "04", t: "Rate your experience", d: "After the service, tell us how it went." },
      ],
    },
    trust: {
      eyebrow: "Trust",
      title: "People helping people.",
      body: "HomeHealthy exists to make everyday life easier, connecting real needs with people willing to help.",
    },
    prosSection: {
      eyebrow: "Professionals",
      title: "Join HomeHealthy.",
      body: "We're looking for responsible, professional people who want to offer their services and help others in Madrid.",
      benefits: [
        "Receive service opportunities",
        "Choose the areas where you want to work",
        "Set your availability",
        "Build your reputation",
        "Be part of a local community",
      ],
      cta: "Become a professional",
    },
    madrid: {
      title: "We're starting in Madrid.",
      body: "Our goal is to build a local network of trust, starting in Madrid and growing neighborhood by neighborhood.",
    },
    ctaFinal: {
      title: "Need a hand today?",
      subtitle: "Tell us what you need and we'll start looking for the right person for you.",
      cta: "I need help",
    },
    footer: {
      tagline: "Everything you need to live well, at home.",
      links: { home: "Home", how: "How it works", what: "Services", pros: "Professionals", help: "I need help" },
      rights: "All rights reserved.",
    },
    publicPro: {
      verified: "Verified professional",
      verifiedNote: "HomeHealthy has reviewed and verified this person.",
      serviceArea: "Service area",
      services: "Services",
      experience: "Experience",
      languages: "Languages",
      about: "About",
      reviews: "Reviews",
      servicesDone: "services completed",
      cta: "I need help",
      directoryTitle: "Verified professionals",
      directorySubtitle: "People reviewed and verified by HomeHealthy in Madrid.",
      back: "Back",
      empty: "No verified professionals published yet.",
      notFound: "This profile is not available.",
    },
    verifiedTeaser: {
      title: "Verified professionals",
      subtitle: "People reviewed by HomeHealthy to give you a network you can trust.",
      cta: "Meet our professionals",
    },
    wizard: {
      title: "I need help",
      steps: ["What you need", "Where", "When", "Tell us more", "Contact"],
      back: "Back",
      next: "Continue",
      submit: "Request help",
      submitting: "Sending…",
      step1: { title: "What do you need?" },
      step2: { title: "Where do you need help?", postal: "Postal code", neighborhood: "Neighborhood", address: "Approximate address (optional)" },
      step3: {
        title: "When?",
        when: ["Today", "Tomorrow", "This week", "Pick a date"],
        date: "Date",
        timeRange: "Time range",
        timeOptions: ["Morning", "Midday", "Afternoon", "Flexible"],
        duration: "Approximate duration",
        durationOptions: ["1 hour", "2 hours", "3 hours", "Half day", "Not sure"],
      },
      step4: { title: "Tell us a bit more", placeholder: "Describe what you need, any detail that helps us…" },
      step5: {
        title: "How can we contact you?",
        name: "Name",
        phone: "Phone",
        email: "Email",
        contact: "How would you prefer to be contacted?",
        contactOptions: ["WhatsApp", "Call", "Email"],
      },
      required: "Please complete the required fields.",
      error: "Something went wrong. Please try again.",
      success: {
        title: "Request received!",
        body: "Thanks for trusting HomeHealthy. Our team will review your request and find the right person to help you in Madrid. We'll contact you to confirm availability, price and schedule.",
        refLabel: "Your request",
        supportTitle: "Need help?",
        supportBody: "Message us on WhatsApp and we'll help with your request.",
        whatsapp: "Message us on WhatsApp",
        back: "Back to HomeHealthy",
      },
    },
    proWizard: {
      title: "Become a professional",
      steps: ["Personal details", "Services", "Experience", "Documents"],
      back: "Back",
      next: "Continue",
      submit: "Send application",
      submitting: "Sending…",
      s1: { title: "Personal details", name: "First name", lastName: "Last name", phone: "Phone", email: "Email", city: "City", postal: "Postal code / areas" },
      s2: { title: "Which services do you offer?", hint: "Select one or more." },
      s3: { title: "Experience", experience: "Experience", languages: "Languages", availability: "Availability", rate: "Indicative hourly rate (€)", description: "Personal description" },
      s4: {
        title: "Documents",
        note: "Add your profile photo and CV. It helps us review your application faster (optional).",
        photo: "Profile photo",
        cv: "CV (PDF)",
        uploadPhoto: "Upload photo",
        uploadCv: "Upload CV",
        uploading: "Uploading…",
        uploaded: "Uploaded ✓",
        status: "On submit, your status will be PENDING REVIEW.",
      },
      required: "Complete the required fields and at least one service.",
      already: "This email is already registered.",
      error: "Something went wrong. Please try again.",
      success: {
        title: "Application received!",
        body: "Thanks for your interest. We'll review your information and get in touch. Your current status is PENDING REVIEW.",
        back: "Back to HomeHealthy",
      },
    },
    review: {
      title: "Rate your experience",
      intro: "How was the service",
      comment: "Comment (optional)",
      submit: "Submit review",
      submitting: "Sending…",
      thanks: "Thanks for your review!",
      already: "This request has already been reviewed.",
      notfound: "We couldn't find that request.",
      close: "Close",
    },
    common: { close: "Close", optional: "optional", privacyPre: "I have read and accept the", privacyLink: "privacy policy", privacyErr: "You must accept the privacy policy." },
    ai: {
      analyze: "Analyze with AI",
      analyzing: "Analyzing…",
      suggested: "Suggested category",
      apply: "Use",
      summaryLabel: "Summary for the team",
      bio: "Generate with AI",
      bioLoading: "Generating…",
      chatTitle: "HomeHealthy Assistant",
      chatIntro: "Hi, I'm the HomeHealthy assistant. How can I help?",
      chatPlaceholder: "Type your question…",
      error: "The assistant is not available right now.",
    },
  },
};
